var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "span",
    [
      _vm._l(_vm.masterEmploymentStatuses, function (masterEmploymentStatus) {
        return [
          _vm.isContainEmploymentStatus(masterEmploymentStatus.id)
            ? _c("img", {
                key: masterEmploymentStatus.id,
                attrs: {
                  src:
                    _vm.userOfferImageUrlForSp +
                    "/" +
                    masterEmploymentStatus.iconName,
                  alt: masterEmploymentStatus.name,
                  "data-test": "employment-" + masterEmploymentStatus.id,
                },
              })
            : _vm._e(),
        ]
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }